
//export const stripe_key = "pk_test_9xPmJZkbUStmNdQc6pdax2jQ"
export const stripe_key = "pk_live_iYb7NErNzfmPqcXbb3n7e43t"

